import { SCREEN_SIZE_KEYS } from 'mm-theme-configuration/dist/consts';

type MEDIA_BREAKPOINTS = {
  [key in SCREEN_SIZE_KEYS]: string
}
export const LARGE_SCREEN_SIZE = 1080;
const MEDIUM_SCREEN_SIZE = 1079;
const SMALL_SCREEN_SIZE = 719;

export const MEDIA_BREAKPOINTS: MEDIA_BREAKPOINTS = {
  LARGE: `@media (min-width: ${LARGE_SCREEN_SIZE}px)`,
  MEDIUM: `@media (max-width: ${MEDIUM_SCREEN_SIZE}px)`,
  SMALL: `@media (max-width:${SMALL_SCREEN_SIZE}px)`,
};
